import React from 'react';

const NavLogoutLink = (): React.ReactElement => (
  <li className="dropdown-item last-ch">
    <a className="nav-link" rel="nofollow" data-method="delete" href="/logout">Logout</a>
  </li>
);

export default NavLogoutLink;
